import React from 'react'
import CommonHeroSection from '../../common/CommonHeroSection'
import CommonBreadcrumb from '../../common/CommonBreadcrumb'
import DynamicTourSection from '../../sections/CommonSection/DynamicToureSection'
import Footer from '../../common/Footer'
import { munnarThekkadyAlleppeyData } from './tourPackageData'
import Header from '../../common/Header'

function MunnarThekkadyAlleppey() {
    return (
        <>
            <Header />
            <CommonHeroSection title="Munnar Thekkady Alleppey Cochin" />
            <CommonBreadcrumb items={["Munnar Thekkady Alleppey Cochin"]} />
            <DynamicTourSection {...munnarThekkadyAlleppeyData} />
            <Footer />
        </>
    )
}

export default MunnarThekkadyAlleppey